export enum AvatarSize {
  XSmall = 'x-small',
  Large = 'large',
  Medium = 'medium',
}
